/*
 * Copyright (c) 2022. Haodong JU
 */

import readXlsxFile from 'read-excel-file'
import hillo from 'hillo'
import sortBy from 'lodash-es/sortBy'
import { groupBy } from 'lodash-es'
import Category from '@/model/dish/Category'
import PrinterGroup from '@/model/print/PrinterGroup'
import Dish from '@/model/dish/Dish'
import IKUtils from 'innerken-js-utils'
import { showSuccessMessage } from '@/common/utils'


async function getDCTList () {
  const res = []
  for (const lang of ['ZH', 'DE', 'EN']) {
    res.push((await hillo.get('CategoryType.php', { lang })).content)
  }
  return Object.values(groupBy(res.flat(), 'id'))
}

async function getDCTIdByName (name) {
  const dctList = await getDCTList()
  return parseInt(dctList.find(i => i.map(it => it.name).includes(name))?.[0]?.id ?? -1)
}

function dishesCategoryHash (dc) {
  dc.langs = sortBy(dc.langs, 'lang')
  return dc.dishesCategoryTypeId + '%' + dc.langs.reduce((str, i) => str + i.name, '')
}

export async function convertFileData (inputFile) {
  IKUtils.showLoading(true)
  // key值为非中文最大程度避免代码转义过程的错误
  const fetchedDishes = []
  const fetchedPrinter = {}
  const fetchedDishesCategory = {}
  const errors = []

  for (const row of inputFile) {
    // create dishCategory
    const dishCategory = {
      printOrder: 50,
      categorySort: 50,
      color: '#F8BBD0',
      langs: [{
        name: row['Category (Chinese)'],
        lang: 'ZH',
      }, {
        name: row['Category (German)'],
        lang: 'DE',
      }, {
        name: row['Category (English)'],
        lang: 'EN',
      }],
      dishesCategoryTypeId: await getDCTIdByName(row['Tax Type']),
    }
    if (dishCategory.dishesCategoryTypeId === -1) {
      errors.push({
        state: 'bad',
        message: 'Tax Type Id not found,please check row' + row,
        row: row,
      })
    }

    let fakeCategoryId = Object.values(fetchedDishesCategory)
      .find(it => dishesCategoryHash(it) === dishesCategoryHash(dishCategory))?.fakeCategoryId ?? -1

    if (fakeCategoryId === -1) {
      fakeCategoryId = 'fakeCategoryId_' + Object.values(fetchedDishesCategory).length

      fetchedDishesCategory[Object.values(fetchedDishesCategory).length] = {
        ...dishCategory,
        realId: null,
        fakeCategoryId,
      }
    }
    // create printer
    const printerName = row.Printer
    let fakePrinterId = Object.values(fetchedPrinter).find(it => it.name === printerName)?.fakePrinterId ?? -1

    const printer = {
      name: printerName,
      isSingleLinePrint: true,
      isSingleOrderPrint: false,
      upsideDown: false,
      defaultRetryCount: '0',
      isReceptionPrinter: false,
    }
    if (fakePrinterId === -1) {
      fakePrinterId = 'fakePrinterGroupId_' + Object.values(fetchedPrinter).length

      fetchedPrinter[Object.values(fetchedPrinter).length] = {
        ...printer,
        realId: null,
        fakePrinterId,
      }
    }

    // create dishes
    const langGroup = [{
      name: row['Name (Chinese)'],
      lang: 'ZH',
      desc: row.Description,
    }, {
      name: row['Name (German)'],
      lang: 'DE',
      desc: row.Description,
    }, {
      name: row['Name (English)'],
      lang: 'EN',
      desc: row.Description,
    }]

    fetchedDishes.push({
      code: row['Product Number'],
      price: row.Price,
      langs: langGroup,
      fakePrinterId,
      fakeCategoryId,
    })
  }

  const categoryList = await Category.getList()
  const printerGroupList = await PrinterGroup.getList()
  const dishList = await Dish.getList()

  if (errors.length > 0) {
    return {
      state: 'bad',
      errors,
    }
  }
  for (const key in fetchedDishesCategory) {
    const res = categoryList.find(j => dishesCategoryHash(fetchedDishesCategory[key]) === dishesCategoryHash(j))
    fetchedDishesCategory[key].realId = res?.id
    fetchedDishesCategory[key].add = !res
    console.log(fetchedDishesCategory[key].add, fetchedDishesCategory[key], 'new DC')
  }

  for (const key in fetchedPrinter) {
    const res = printerGroupList.find(j => fetchedPrinter[key].name === j.name)
    fetchedPrinter[key].realId = res?.id
    fetchedPrinter[key].add = !res
  }

  fetchedDishes.forEach((i, index) => {
    fetchedDishes[index].add = !dishList.find(j => i.code === j.code)
  })

  showSuccessMessage('OK')

  return {
    state: 'good',
    fetchedData: {
      categoryDict: fetchedDishesCategory,
      printerDict: fetchedPrinter,
      dishList: fetchedDishes,
    },
  }
}

export async function upload (fetchedDishesCategory, fetchedPrinter, fetchedDishes) {
  IKUtils.showLoading(true)
  for (const key in fetchedDishesCategory) {
    if (fetchedDishesCategory[key].add) {
      const res = await Category.add(fetchedDishesCategory[key])
      fetchedDishesCategory[key].add = !res
      fetchedDishesCategory[key].realId = res?.content?.id
      console.log(res, 'Category res')
    }
  }

  for (const key in fetchedPrinter) {
    if (fetchedPrinter[key].add) {
      const res = await PrinterGroup.add(fetchedPrinter[key])
      fetchedPrinter[key].add = !res
      fetchedPrinter[key].realId = res?.content?.id
      console.log(res, 'Printer res')
    }
  }

  for (const key in fetchedDishes) {
    fetchedDishes[key].categoryId = await convertFakeCategoryId(fetchedDishes[key].fakeCategoryId, fetchedDishesCategory)
    fetchedDishes[key].printGroupId = await convertFakePrinterId(fetchedDishes[key].fakePrinterId, fetchedPrinter)

    if (fetchedDishes[key].add) {
      await Dish.add(fetchedDishes[key])
    } else {
      const res = await hillo.postWithUploadFile('Dishes.php?op=update', {
        ...fetchedDishes[key],
        params: JSON.stringify(fetchedDishes[key]),
      }, { showLoading: false })

      console.log(res, '上传菜品')
      // await Dish.edit(fetchedDishes[key])
    }
  }
}

export async function convertFakeCategoryId (fakeId, fetchedDishesCategory) {
  for (const key in fetchedDishesCategory) {
    if (fetchedDishesCategory[key].fakeCategoryId === fakeId) {
      return fetchedDishesCategory[key].realId
    }
  }
}

export async function convertFakePrinterId (fakeId, fetchedPrinter) {
  for (const key in fetchedPrinter) {
    if (fetchedPrinter[key].fakePrinterId === fakeId) {
      return fetchedPrinter[key].realId
    }
  }
}

export async function parseExcel (file) {
  const res = await readXlsxFile(file)
  const header = res[2]
  return res.splice(4).map(body => {
    return Object.assign(...header.map((k, i) => ({ [k]: body[i] })))
  })
}

export async function checkFileType (file) {
  return (file && file?.name && ((file.name.split('.').pop().toLowerCase() === 'xls') || file.name.split('.').pop().toLowerCase() === 'xlsx'))
}
